import React, { Component } from 'react';
import '../../common/index.scss';

class Fashion extends Component {

	render() {
        return <div/>
	}
}

export default Fashion;